module.exports = __webpack_public_path__ + "img/Artboard2.8a55f734.webp";